import styled from 'styled-components';
import Link from '../Link';
import { fontSize } from '../../style/utils';

interface LabelLinkProps {
  as?: keyof JSX.IntrinsicElements;
  size?: 'small' | 'medium' | 'large';
}

const LabelLink = styled(Link).attrs<LabelLinkProps>(({ size = 'medium' }) => ({
  size,
}))<LabelLinkProps>`
  font-size: ${({ size }) =>
    size === 'small'
      ? fontSize('sm')
      : size === 'large'
      ? fontSize('lg')
      : fontSize('base')};
  font-weight: ${({ theme }) => theme.typography.fontWeightBold};

  color: ${({ theme }) => theme.palette.content.primary};

  cursor: pointer;
  text-decoration: underline;
  transition: color 0.3s ease;

  &:hover {
    color: ${({ theme }) => theme.palette.accent.primary};
  }
`;

export default LabelLink;
